import React, { FC } from 'react';
import { CustomToastContainer } from '../../../components/toaster/CustomToastContainer';
import { Office } from './Office';
import { Sticker } from '../../../components/sticker/Sticker';
import { LawFirmMobileBar } from '../sub-header/LawFirmMobileBar';
import { LawFirmInfos } from '../../lawFirm.types';
import { LawFirmSubHeader } from '../sub-header/LawFirmSubHeader';
import { PageContainer } from '../../../components/page-container/PageContainer';
import { Page, PageLeft } from '../../../components/page/Page';

type Props = {
  lawFirmInfos: LawFirmInfos;
  accessPremium: boolean;
};

export const OfficeMain: FC<Props> = ({ lawFirmInfos, accessPremium }) => (
  <>
    <Sticker anchor="add-watcher-law-firm" margin="law-firm-sub-header">
      {({ isVisible }: { isVisible: boolean }) => (
        <LawFirmSubHeader isVisible={isVisible} lawFirmInfos={lawFirmInfos} />
      )}
    </Sticker>
    <CustomToastContainer />
    <div className="entity">
      <PageContainer>
        <Page>
          <PageLeft />
          <Office lawFirmInfos={lawFirmInfos} accessPremium={accessPremium} />
        </Page>
        <Sticker anchor="add-watcher-law-firm">
          {({ isVisible }: { isVisible: boolean }) => (
            <LawFirmMobileBar
              isVisible={isVisible}
              lawFirmInfos={lawFirmInfos}
            />
          )}
        </Sticker>
      </PageContainer>
    </div>
  </>
);
